/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Error_DescInputs */

const es_toast_error_desc = /** @type {(inputs: Toast_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal`)
};

const en_toast_error_desc = /** @type {(inputs: Toast_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Toast_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_error_desc = /** @type {((inputs?: Toast_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_error_desc(inputs)
	return en_toast_error_desc(inputs)
});
export { toast_error_desc as "toast.error_desc" }